import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createRWHR = (payload) => post(baseURL + url.RWHR, payload);
export const getRWHRDetails = (id) => get(`${baseURL + url.RWHR}/${id}`);
export const updateRWHR = (id, payload) => put(`${baseURL + url.RWHR}/${id}`, payload);
export const deleteRWHR = (id) => remove(`${baseURL + url.RWHR}/${id}`);
